Namespace 'Common.Dashboard'

class Common.Dashboard.RefreshIntervalModel extends Backbone.Model
  defaults:
    options: [0, 30, 60, 120, 300, 600, 1800]
    selectedOption: 0
